var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeMinimum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.83043C13 3.36304 11.3027 2.54726 10.1568 3.4639L6.07931 6.7259C5.85766 6.90321 5.58227 6.99981 5.29844 6.99981H3.75C2.23122 6.99981 1 8.23103 1 9.74981V14.2498C1 15.7686 2.23122 16.9998 3.75 16.9998H5.29844C5.58234 16.9998 5.85777 17.0965 6.07932 17.2738L10.1568 20.5357C11.3026 21.4522 13 20.6367 13 19.1692V4.83043ZM11.0938 4.63523C11.2575 4.50424 11.5 4.62082 11.5 4.83043V19.1692C11.5 19.3787 11.2576 19.4954 11.0938 19.3644L7.01634 16.1025C6.52865 15.7122 5.92278 15.4998 5.29844 15.4998H3.75C3.05964 15.4998 2.5 14.9402 2.5 14.2498V9.74981C2.5 9.05946 3.05964 8.49981 3.75 8.49981H5.29844C5.92288 8.49981 6.52874 8.28729 7.01635 7.8972L11.0938 4.63523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.114 9.6242C15.9065 9.26568 15.4477 9.1432 15.0892 9.35065C14.7307 9.55809 14.6082 10.0169 14.8156 10.3754C15.0917 10.8526 15.25 11.4066 15.25 11.9998C15.25 12.5931 15.0917 13.147 14.8156 13.6244C14.6082 13.9829 14.7307 14.4417 15.0892 14.6491C15.4478 14.8565 15.9066 14.734 16.114 14.3755C16.5187 13.676 16.75 12.8638 16.75 11.9998C16.75 11.1359 16.5187 10.3236 16.114 9.6242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMinimum);
export default __webpack_public_path__ + "static/media/volume-minimum.ef5768629a3d027e57bd3cd9b6124146.svg";
export { ForwardRef as ReactComponent };